<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('sportCenter')"></TitlePage>

    <div class="d-flex justify-end mb-2" v-if="getUser.super_admin && $route.params.id">
      <ExternalPlatformLink :href="marketingCenterUrl($route.params.id)">Apri il centro nel marketing</ExternalPlatformLink>
    </div>

    <v-layout wrap>

      <v-flex md12 class="d-flex">
        <v-chip color="primary" label small text-color="white">{{$t('genericInfo')}}</v-chip>
      </v-flex>

      <v-flex md5 class="pl-4 pr-4">
        <v-text-field :label="$t('name')" v-model="item.name" :rules="validation.textRules" :error-messages="errors.name" @change="makeSlug" @input="makeSlug"></v-text-field>
      </v-flex>

      <v-flex md5 class="pl-4 pr-4">
        <v-text-field :label="$t('slug')" v-model="item.slug" :rules="validation.textRules" :error-messages="errors.slug"></v-text-field>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4">
        <v-switch v-model="item.active" inset :label="$t('status')" dense hide-details v-if="this.getUser.super_admin"></v-switch>
      </v-flex>

      <v-flex md12 class="pl-4 pr-4">

        <v-autocomplete
            id="map"
            prepend-icon="mdi-map-marker"
            v-model="item.address_complete" :items="google_places_results" :loading="google_places_loading"
            :search-input.sync="google_places_search" hide-no-data hide-selected disable-lookup :placeholder="$t('addressComplete')"
            clearable return-object :rules="validation.textRules" no-filter @change="setResult"
        ></v-autocomplete>
      </v-flex>

      <v-flex md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">{{$t('companyInfo')}}</v-chip>
      </v-flex>

      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('company')" v-model="item.company_info.company" @input="copyToFinancial" @change="copyToFinancial"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('address')" v-model="item.company_info.address"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('city')" v-model="item.company_info.city"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('province')" v-model="item.company_info.province"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('postal_code')" v-model="item.company_info.postal_code"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('country')" v-model="item.company_info.country"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('phone')" v-model="item.company_info.phone"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('email')" v-model="item.company_info.email"></v-text-field>
      </v-flex>

      <v-flex md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">{{$t('financialInfo')}}</v-chip>
      </v-flex>

      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('company')" v-model="item.financial_info.company"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('address')" v-model="item.financial_info.address"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('city')" v-model="item.financial_info.city"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('province')" v-model="item.financial_info.province"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('postal_code')" v-model="item.financial_info.postal_code"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('country')" v-model="item.financial_info.country"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('vat_code')" v-model="item.financial_info.vat_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('fiscal_code')" v-model="item.financial_info.fiscal_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('sdi_code')" v-model="item.financial_info.sdi_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('pec_address')" v-model="item.financial_info.pec_address"></v-text-field>
      </v-flex>

      <v-flex md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">{{$t('settings')}} {{$t('PromoCode')}}</v-chip>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-checkbox
            v-model="item.enable_promo_code_promo_sa_global"
            label="Accetta Promo Code uCamp"
            :readonly="!this.getUser.super_admin"
            :disabled="!this.getUser.super_admin"
        ></v-checkbox>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-checkbox
            v-model="item.enable_promo_code_promo_center"
            label="Accetta Promo Code Centro"
        ></v-checkbox>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import ExternalPlatformLink from "@/components/utils/ExternalPlatformLink";
import {marketingCenterUrl} from "@/utils/platforms";
import {mapGetters, mapMutations, mapActions} from 'vuex';
const slugify = require('slugify')

export default {
  name: "EditCenter",
  components: {TitlePage, ExternalPlatformLink},
  computed:{
    ...mapGetters({
      'getUser':'user/getUser'
    })
  },
  data() {
    return {
      google_places_results: [],
      google_places_loading: false,
      google_places_search: '',
      google_places_service: null,
      detail_google_places_service: null,
      item: {
        name: '',
        slug: '',
        address_complete: "",
        position:{
          type: "",
          coordinates:[]
        },
        company_info: {
          company: "",
          address: "",
          city: "",
          province: "",
          postal_code: "",
          country: "",
          phone: "",
          email: ""
        },
        financial_info: {
          company: "",
          address: "",
          city: "",
          province: "",
          postal_code: "",
          country: "",
          vat_code: "",
          fiscal_code: "",
          sdi_code: "",
          pec_address: ""
        },
        active: false,
        enable_promo_code_promo_sa_global: false,
        enable_promo_code_promo_center: false,
      },
      check: true,
      errors:{
        name: '',
        slug: '',
        address_complete: '',
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ]
      }
    };
  },
  watch: {
    google_places_search (newValue) {
      if (newValue && newValue.length >= 3 && !this.google_places_loading) {
        this.google_places_loading = true
        this.google_places_service.getPlacePredictions({
          input: this.google_places_search,
          types: ['address'],
          language: 'it',
          componentRestrictions: {
            country: 'it'
          },
        }, this.displaySuggestions)
      }
    }
  },
  async created(){
    if(!this.getUser.super_admin && this.getUser.center_id != this.$route.params.id){
      this.$router.push('/')
      return
    }
    this.setLoading(true);
    var fetchItem = await this.editItem(this.$route.params)

    this.item.name = fetchItem.result.name;
    this.item.slug = fetchItem.result.slug;
    this.item.address_complete = fetchItem.result.address_complete;
    this.google_places_search = fetchItem.result.address_complete;
    this.google_places_results.push(fetchItem.result.address_complete)
    this.item.position = fetchItem.result.position;
    this.item.company_info = fetchItem.result.company_info;
    this.item.financial_info = fetchItem.result.financial_info;
    this.item.active = fetchItem.result.active;
    this.item.enable_promo_code_promo_sa_global = fetchItem.result.enable_promo_code_promo_sa_global ? fetchItem.result.enable_promo_code_promo_sa_global : false;
    this.item.enable_promo_code_promo_center = fetchItem.result.enable_promo_code_promo_center ? fetchItem.result.enable_promo_code_promo_center : false;
    this.setLoading(false);
  },
  methods: {
    marketingCenterUrl,
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'centers/edit',
      'updateItem':'centers/update',
    }),
    async update(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.item.name){
        this.check = false
        this.errors.name = this.$t('fillMandatory');
      }

      if(!this.item.slug){
        this.check = false
        this.errors.slug = this.$t('fillMandatory');
      }

      if(!this.item.address_complete){
        this.check = false
        this.errors.address_complete = this.$t('fillMandatory');
      }

    },

    async makeSlug(){
      this.item.slug = slugify(this.item.name, {remove: /[*+~.()'"!:@,/]/g,lower: true, locale: 'it'})
    },
    copyToFinancial(){
      this.item.financial_info.company = this.item.company_info.company
    },
    async setResult(){

      let address = JSON.parse(JSON.stringify(this.item.address_complete))
      this.item.address_complete = this.item.address_complete.text

      var geocoder = new google.maps.Geocoder();
      var result_geocoder = await geocoder.geocode({placeId:address.id})

      if(result_geocoder.results[0].address_components.length > 0){

        let placeResultData = result_geocoder.results[0]
        let country
        let city
        let province
        let postal_code
        let street
        let number

        for(let c of placeResultData.address_components){
          if(c.types.includes('country')){
            country = c.short_name
          }else if(c.types.includes('locality')){
            city = c.long_name
          }else if(c.types.includes('administrative_area_level_2')){
            province = c.short_name
          }else if(c.types.includes('postal_code')){
            postal_code = c.long_name
          }else if(c.types.includes('street_number')){
            number = c.short_name
          }else if(c.types.includes('route')){
            street = c.long_name
          }
        }

        this.item.position.type = "Point"
        this.item.position.coordinates = [
          placeResultData.geometry.location.lng(),
          placeResultData.geometry.location.lat()
        ]


        let address_info = (number) ? street+','+number : street

        this.item.company_info.address = address_info
        this.item.company_info.city = city
        this.item.company_info.province = province
        this.item.company_info.postal_code = postal_code
        this.item.company_info.country = country

        this.item.financial_info.address = address_info
        this.item.financial_info.city = city
        this.item.financial_info.province = province
        this.item.financial_info.postal_code = postal_code
        this.item.financial_info.country = country

      }

    },

    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {

        this.google_places_results = []
        this.google_places_loading = false

      }else {

        this.google_places_results = []
        predictions.map((x) => {
          this.google_places_results.push({
            'text': x.description,
            'id': x.place_id
          })
        })
        this.google_places_loading = false

      }
    },

    setAddressData: function (addressData, placeResultData, id) {

      this.item.position.type = "Point"
      this.item.position.coordinates = [addressData.longitude, addressData.latitude]

      var country = placeResultData.address_components.filter((info) => {
        if(info.types.includes('country')){
          return info
        }
      })

      this.item.company_info.address = addressData.name
      this.item.company_info.city = addressData.locality
      this.item.company_info.province = addressData.administrative_area_level_2
      this.item.company_info.postal_code = addressData.postal_code
      this.item.company_info.country = (country[0].short_name) ? country[0].short_name : addressData.country

      this.item.financial_info.address = addressData.name
      this.item.financial_info.city = addressData.locality
      this.item.financial_info.province = addressData.administrative_area_level_2
      this.item.financial_info.postal_code = addressData.postal_code
      this.item.financial_info.country = (country[0].short_name) ? country[0].short_name : addressData.country

    },

    async resetError(){
      this.errors = {
        name: '',
        slug: '',
        address_complete: '',
      }
    },

  },
  mounted() {
    this.google_places_service = new window.google.maps.places.AutocompleteService()
  },
}
</script>

<style scoped>

</style>